import styled from "styled-components"
import ReactMarkdown from "react-markdown"
import React, { memo, useCallback, useEffect, useMemo, useState } from "react"
import remarkGfm from "remark-gfm"
import useMapData, { ApiPoint } from "../../hooks/queries/use-map-data"
import { FaSearch } from "react-icons/fa"
import { useForm } from "react-hook-form"
import { SvgCategoryIcon } from "./Sidebar"
import Fuse from "fuse.js"
import { CDN_URL } from "../../config/games"
// @ts-ignore
import { Virtuoso } from "react-virtuoso"
import { Category } from "../PointPopup"

const PAGE_SIZE = 50

export default memo(function Search({ staticDataUrl }: { staticDataUrl?: string }) {
  const { categoryMap, groupMap, search, searchResults } = useMapData(staticDataUrl)
  const [searchResultsVirtuoso, setSearchResultsVirtuoso] = React.useState<Fuse.FuseResult<ApiPoint>[]>([])

  const [currentSearchTerm, setCurrentSearchTerm] = useState("")

  const Footer = () => (
    <div
      style={{
        padding: "2rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {!searchResults.length && "No results found"}
      {searchResults.length && searchResults.length === searchResultsVirtuoso.length
        ? `${searchResultsVirtuoso.length} results`
        : null}
      {searchResults.length && searchResults.length !== searchResultsVirtuoso.length ? "Loading..." : null}
    </div>
  )

  const searchForm = useForm({
    defaultValues: {
      search: "",
    },
  })

  const loadMore = () => {
    setSearchResultsVirtuoso(searchResults.slice(0, searchResultsVirtuoso.length + PAGE_SIZE))
  }
  useEffect(() => {
    setSearchResultsVirtuoso(searchResults.slice(0, PAGE_SIZE))
  }, [searchResults])

  const renderSearchResults = (
    <div className="scrollbar-wrap" style={{ display: "flex", flexDirection: "column", gap: 10, height: "100%" }}>
      <Virtuoso
        style={{ height: "calc(100% - 50px)" }}
        data={searchResultsVirtuoso}
        endReached={loadMore}
        // overscan={200}
        itemContent={(i: number, result: Fuse.FuseResult<ApiPoint>) => {
          const point = result.item
          return (
            <Card key={point.id} color={groupMap[categoryMap[point.categoryId].groupId].color}>
              <h2 className="title">
                <SvgCategoryIcon
                  url={`${CDN_URL}/assets/category-bare/${categoryMap[point.categoryId]?.shortName}.svg`}
                  isActive
                />
                <a href={`#${point.id}`} style={{textDecoration: "none"}}>
                  <ReactMarkdown
                    remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
                    components={{
                      del: "mark",
                    }}
                  >
                    {point.name.replaceAll(new RegExp(currentSearchTerm, "gmi"), (match) => `~~${match}~~`) || ""}
                  </ReactMarkdown>
                </a>
              </h2>
              <Category className="h6">{categoryMap[point.categoryId]?.name}</Category>

              <div className="small">
                <ReactMarkdown
                  remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
                  components={{
                    del: "mark",
                  }}
                >
                  {point.description?.replaceAll(new RegExp(currentSearchTerm, "gmi"), (match) => `~~${match}~~`) || ""}
                </ReactMarkdown>
              </div>
            </Card>
          )
        }}
        components={{ Footer }}
      />
    </div>
  )

  return (
    <>
      <form
        onSubmit={searchForm.handleSubmit((data) => {
          search(data.search)
          setCurrentSearchTerm(data.search)
        })}
      >
        <label htmlFor="search">Search</label>
        <Field>
          <input {...searchForm.register("search")} autoComplete="off" />
          <button>
            <FaSearch /> Search
          </button>
        </Field>
      </form>
      {renderSearchResults}
    </>
  )
})

const Card = styled.div<{ color?: string }>`
  padding: 10px;
  border-bottom: 1px solid #505050;
  .title {
    display: flex;
    align-items: center;
  }
  display: flex;
  flex-direction: column;
  gap: 5px;
  .small {
    font-size: 0.8em;
  }
  border-left: 5px solid ${(props) => props.color || props.theme.colors.white};
`

const Field = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  height: 30px;
  border: 1px solid #ccc;
  border-left: 5px solid ${(props) => props.theme.colors.primary};

  input {
    padding: 0 5px;
    margin: 0;
    color: white;
    border: none !important;
    :hover,
    :active,
    :focus {
      border: none;
      outline: none;
    }
    border-radius: 0;
    flex-grow: 1;
    font-size: 1rem;
    background-color: transparent;
  }

  button {
    cursor: pointer;
    color: white;
    border: none;
    background: none;
    padding: 0.5rem;
  }
`
